import { render, staticRenderFns } from "./GroupConversationProvider.vue?vue&type=template&id=5c64facc"
import script from "./GroupConversationProvider.vue?vue&type=script&lang=ts"
export * from "./GroupConversationProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c64facc')) {
      api.createRecord('5c64facc', component.options)
    } else {
      api.reload('5c64facc', component.options)
    }
    module.hot.accept("./GroupConversationProvider.vue?vue&type=template&id=5c64facc", function () {
      api.rerender('5c64facc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupConversationProvider.vue"
export default component.exports